module.exports = __webpack_public_path__ + "static/media/matilde-hat-greece-normal.3a1efb14.png";